import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { UitkFloatingButton } from "@egds/react-core/button";
import { UitkPageLoader } from "@egds/react-core/loader";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { useLocalization } from "@shared-ui/localization-context";

export interface EGMapSearchButtonProps {
  /**
   * The button will be disabled if this prop is true
   */
  isSearchInProgress?: boolean;

  /**
   * Button text
   */
  searchMessage?: string;

  /**
   * Event callback called when the user clicks on the search button
   */
  onMapSearch?: () => void;

  changedBounds?: any;
}

export const EGMapSearchButton: React.FC<EGMapSearchButtonProps> = ({
  isSearchInProgress,
  onMapSearch,
  changedBounds,
  ...props
}) => {
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  function usePrevious<T>(value: T): T | null {
    const ref = useRef<T | null>(null);
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const [isVisibleSearchButton, setIsVisibleSearchButton] = useState(false);
  const previousIsSearchInProgress = usePrevious<boolean>(isSearchInProgress!);
  const { formatText } = useLocalization();
  const [bounds, setBounds] = useState();

  useEffect(() => {
    if (previousIsSearchInProgress && !isSearchInProgress) {
      setIsVisibleSearchButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearchInProgress]);

  useEffect(() => {
    if (changedBounds && bounds !== changedBounds) {
      setIsVisibleSearchButton(true);
    } else {
      setIsVisibleSearchButton(false);
    }
    setBounds(changedBounds);
  }, [changedBounds]);

  const searchMessage = props.searchMessage || formatText("maps.fullscreen.searchThisArea");

  return (
    <>
      {isVisibleSearchButton && (
        <UitkFloatingButton disabled={isSearchInProgress} onClick={onMapSearch}>
          {searchMessage}
        </UitkFloatingButton>
      )}
      {isSearchInProgress && (
        <UitkLayoutPosition type="absolute" position={{ top: "center", left: "center", zindex: "layer7" }}>
          <UitkPageLoader visible />
        </UitkLayoutPosition>
      )}
    </>
  );
};

EGMapSearchButton.displayName = "EGMapSearchButton";

EGMapSearchButton.defaultProps = {
  isSearchInProgress: false,
};
